<adapt-dialog [width]="1000"
              [fitHeight]="true">
    <h3 adapt-dialog-title>{{dialogTitle}}</h3>

    <div adapt-dialog-content
         class="d-flex gap-3 h-100">
        <div class="selector-column">
            @if (!dialogData.recentMeetingOnly) {
                <div>
                    <h3>Import from</h3>
                    <dx-radio-group [items]="ImportTypes"
                                    [value]="selectedImportType"
                                    (valueChange)="onImportTypeChange($event)"
                                    valueExpr="type"
                                    displayExpr="text"
                                    layout="horizontal"></dx-radio-group>
                </div>
            }
            @switch (selectedImportType) {
                @case (ImportType.FromTemplate) {
                    <adapt-template-selector class="selector"
                                             [ngClass]="{'no-type-selector': dialogData.recentMeetingOnly}"
                                             [currentTeam]="dialogData.currentMeeting?.team || dialogData.currentTeam"
                                             (selectedAgendaTemplateChange)="templateSelected($event.meetingTemplate)"></adapt-template-selector>
                }
                @case (ImportType.FromMeeting) {
                    <adapt-recent-meeting-selector class="selector"
                                                   [ngClass]="{'no-type-selector': dialogData.recentMeetingOnly}"
                                                   [currentMeeting]="dialogData.currentMeeting"
                                                   [currentTeam]="dialogData.currentMeeting?.team || dialogData.currentTeam"
                                                   (meetingSelected)="meetingSelected($event)"></adapt-recent-meeting-selector>
                }
            }
        </div>

        <div class="agenda-items-column">
            <dx-scroll-view class="p-2">
                @if (selectedMeeting || selectedTemplate) {
                    <h3 class="ms-2">Agenda items</h3>
                    <div *adaptLoading="loadingItems">
                        <adapt-display-agenda-items [agendaItems]="agendaItems"
                                                    [hideProgressIcon]="true"
                                                    [hideNotesAndItems]="true"
                                                    class="import-agenda-items"></adapt-display-agenda-items>
                    </div>
                } @else {
                    <div class="alert alert-info">
                        <p>To import agenda items, select a meeting or template.</p>
                        <p>Click on the meeting or template name from the left panel to view its corresponding agenda items. Once selected,
                            the
                            agenda items will appear in this area for review before importing.</p>
                        <p>You can scroll through the available meetings or templates to find the one that best matches your current needs.
                        </p>
                        <p>After selecting a meeting or template, you can import all its agenda items with a single click using the Import
                            button below.</p>
                        <p><small>Note: Only meetings within 18 months in the past and 2 weeks in the future are shown.</small></p>
                    </div>
                }
            </dx-scroll-view>
        </div>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   (cancelClick)="cancel()"
                                   [saveIsDisabled]="(!selectedMeeting && !selectedTemplate) || loadingItems"
                                   saveButtonPreset="add"
                                   [saveText]="dialogData.saveOnClose ? 'Import & save' : 'Import'"
                                   [saveBlockingClick]="importItems"></adapt-standard-dialog-buttons>
</adapt-dialog>
